var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"display-ticket-cover-wrapper"},[(!_vm.value)?_c('div',{staticClass:"skeleton-wrapper"},[_c('van-skeleton',{attrs:{"row":5}})],1):_c('div',[_c('display-image',{attrs:{"value":_vm.value}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }